import * as r from "react";
import { d as s } from "./index-DcwNtM_b.js";
var u = r[" useId ".trim().toString()] || (() => {
}), i = 0;
function n(e) {
  const [t, o] = r.useState(u());
  return s(() => {
    o((a) => a ?? String(i++));
  }, [e]), t ? `radix-${t}` : "";
}
export {
  n as u
};
//# sourceMappingURL=index-CDznMoQN.js.map
